import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ConfirmDirective} from "../../../../../directives/confirm/confirm.directive";
import {IsGrantedDirective} from "../../../../../directives/is-granted/is-granted.directive";
import {PartnerXAdsService} from '../../../../../services/partner/partner-x-ads.service';
import {PartnerAdvertisingPlatform} from '../../../../../models/partner/partner-advertising-platform';

@Component({
  imports: [
    ConfirmDirective,
    IsGrantedDirective
  ],
  selector: 'app-x-ads-config-form',
  styleUrl: './x-ads-config-form.component.scss',
  templateUrl: './x-ads-config-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class XAdsConfigFormComponent implements OnChanges {
  @Input() partnerAdvertisingPlatform: PartnerAdvertisingPlatform | null = null;

  conversionGoals: any[] | null = null;
  partnerId: number | null = null;

  constructor(
    private partnerXAdsService: PartnerXAdsService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['partnerAdvertisingPlatform']) {
      this.partnerId = this.partnerAdvertisingPlatform?.partnerId ?? null;
      this.refreshActionStatus();
    }
  }

  refreshActionStatus(): void {
    const authInfo = this.partnerAdvertisingPlatform?.authenticationInfo;

    if (this.partnerId && authInfo && authInfo.accountId) {
      this.conversionGoals = null;
      this.partnerXAdsService.getConversionGoalsStatus(this.partnerId).subscribe((goals) => {
        this.conversionGoals = goals;
      });
    }
  }

  createActions(): void {
    if (this.partnerId) {
      this.conversionGoals = null;
      this.partnerXAdsService.createConversionGoalsStatus(this.partnerId).subscribe(() => {
        this.refreshActionStatus();
      });
    }
  }
}
